import { v4 as uuid } from 'uuid'

/**
 * Generate a unique identifier.
 */
export function createIdentificationUniqueId(): string {
  return uuid()
}
